export class DateHelper {

    static formatDate(date: Date): string {
        const day = "0" + date.getDate();
        const month = "0" + (date.getMonth() + 1);
        const year = date.getFullYear();
        return `${year}-${month.substring(month.length - 2)}-${day.substring(day.length - 2)}`;
    }

}